export const HashPage = () => {
  console.log(import.meta.env)
  return <div>hash: {import.meta.env.VITE_VERSION}</div>
}
